/** Tokens visuais — definição de taxas (marca TNV) */
export const TAXAS_ACCENT = "#F96030";
export const TAXAS_INK = "#1a2035";

export const modalPaperSx = {
  borderRadius: 3,
  overflow: "hidden",
  maxHeight: "92vh",
  display: "flex",
  flexDirection: "column" as const,
  width: { xs: "100%", sm: "96vw" },
  maxWidth: 560,
};

export const modalHeaderSx = {
  px: 3,
  py: 2.5,
  background: `linear-gradient(135deg, ${TAXAS_INK} 0%, #2d3561 100%)`,
  color: "#fff",
  borderBottom: `3px solid ${TAXAS_ACCENT}`,
};

export const fieldSx = {
  "& .MuiOutlinedInput-root": { borderRadius: 1.5 },
};

export const taxasToolbarSx = {
  mb: 2,
  p: 2,
  borderRadius: 2,
  bgcolor: "grey.50",
  border: "1px solid",
  borderColor: "grey.200",
  borderLeft: `4px solid ${TAXAS_ACCENT}`,
};
